<div class="modal-header-custom d-flex flex-row">
    <mat-icon (click)="close()" class="close">close</mat-icon>
  </div>
  
  <mat-dialog-content style="max-height: 87vh;">
    <mat-horizontal-stepper>
      <mat-step>
        <div *ngIf="!loading" class="row info">
          <div class="col-3">{{ 'LOGIN.FIRSTNAME' | translate | uppercase }}</div>
          <div class="col-9">{{host.firstName}}</div>
        </div>
        <div *ngIf="!loading" class="row info">
            <div class="col-3">{{ 'LOGIN.LASTNAME' | translate | uppercase }}</div>
            <div class="col-9">{{host.lastName}}</div>
          </div>
        <div *ngIf="!loading" class="row info">
          <div class="col-6">{{ 'LOGIN.EMAIL' | translate | uppercase }}</div>
          <div class="col-6">{{host.email}}</div>
        </div>
        <div *ngIf="!loading" class="row info">
          <div class="col-6">{{ 'LOGIN.PHONE' | translate | uppercase }}</div>
          <div class="col-6">{{host.phone}}</div>
        </div>
        <div *ngIf="!loading" class="row mb-5">
          <div class="col-12">
            <app-multi-select-venue
            #venueList
            *ngIf="operationType == 4"  
            [checkedItems]="host.venueIds" 
            [operation]="operationType"
            >
          </app-multi-select-venue>
            <div></div>
          </div>
        </div>
        <div *ngIf="loading" class="row info">
          <mat-spinner style="margin-top: 80px; margin-bottom: 80px;" class="api-data-spinner"></mat-spinner>
        </div>
        <div class="d-flex flex-row nav-items">
          <div style="margin-top: 48px; margin-bottom: 32px;" class="row">
            <div class="col-6">
              <button style="border: none; width: 234px; height: 36px;" class="mat-bakcground-primary mat-raised-button"(click)="openEditVenue(hostId)">{{ 'EDIT' | translate }}</button>
            </div>
            <div class="col-6">
              <button style="width: 234px; height: 36px;" class="mat-raised-button"(click)="deactivateHost(hostId)">{{'HOST.DEACTIVATE'|translate}}</button>
            </div>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-dialog-content>